(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define("nucleus", ["react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["nucleus"] = factory(require("react"), require("react-dom"));
	else
		root["nucleus"] = factory(root["React"], root["ReactDOM"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__4012__, __WEBPACK_EXTERNAL_MODULE__6003__) {
return 